<template>


    <el-button v-if="visible" :disabled="disabled" type="info" :loading="loading" plain size="small" @click="requestWorkflowInfo"><i
            class="fa fa-retweet"></i> 发送工作流
    </el-button>


</template>


<script>

    import WorkflowApi, {WorkflowApiNew} from '../../api/workflow/workflow'

    export default {

        name: 'workflowRequestBtn',

        props: {
            bussiness: {},
            bussinessId: {},
            visible: {},
            bussinessInfo: {},
            disabled: {},
            errorMsg: {},
            useNewApi: {
                type: Boolean,
                default: false,
            },
            loading: {
              type: Boolean,
              default: false,
            },
            isCanSend: {
                type: Function,
                default: () => Promise.resolve(true),
            },
        },

        data() {

            return {

                workflowRequestInfo: {
                    wfToken: '',
                    ownerId: '',
                    nodeInfo: {},
                }

            }

        },

        computed: {
            api() {
                return this.useNewApi === true ? WorkflowApiNew : WorkflowApi;
            }
        },

        methods: {

            async requestWorkflowInfo() {

                if (this.errorMsg) {
                    this.$message.error(this.errorMsg);
                    return;
                }

                let canSend = false;
                try {
                    canSend = await this.isCanSend();
                } catch (e) {
                    canSend = false;
                    this.$message.error(e);
                }
                if (!canSend) {
                    return;
                }

                let params = {
                    bussiness: this.bussiness,
                    bussinessId: this.bussinessId,
                }
                params.params = {...this.bussinessInfo}.params;
                this.api.request(params).then((responseBody) => {

                    this.workflowRequestInfo.wfToken = responseBody.wfToken;
                    this.workflowRequestInfo.ownerId = responseBody.ownerId;
                    this.workflowRequestInfo.nodeInfo = responseBody.node_info;
                    this.workflowRequestInfo.params = params.params;

                    this.$emit('afterRequestWorkflowFunc', this.workflowRequestInfo);

                }).catch(error => {
                    this.$message.error(error);
                });
            },


        },


    }
</script>
